export * from "./category-item";
export * from "./category-presenter";

import { CategoryItemComponent } from "./category-item";
import { CategoryPresenterComponent } from "./category-presenter";


export const CategoryAtoms = [
    CategoryItemComponent,
    CategoryPresenterComponent
];